import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import viewUtils from "../../utils/viewUtils";
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Image, Typography, Row, Col, Tabs, ConfigProvider, Carousel } from "antd";
import ErrorImage from '../../common/images/ErrorImage';

import {
  getArticleApi,
  getArticleLinksApi,
} from "../../api/WebApi";

const ArticlePage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { article_id } = useParams();
  const [article, setArticle] = useState<any>();
  const [articleLinks, setArticleLinks] = useState<any>();


  useEffect(() => {
    if(!!article_id) {
      getArticleApi(article_id).then((res) => {
        if(res.status) {
          setArticle(res.data)
        }
      })
    }
  }, [article_id])

  useEffect(() => {
    if(!!article?.category?.menu?.page_config?.can_link) {
      getArticleLinksApi(article.id).then((res) => {
        if(res.status) {
          setArticleLinks(res.data)
        }
      })
    }
  }, [article])

  const CommonArticleView = () => {
    return <>
      <Typography.Title className='article-title' style={{marginBottom: '1em'}}>
        { viewUtils.prettyWithLang(article?.name, i18n.language)}
      </Typography.Title>
      <div style={{
        display: 'flex',
        // justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: "3em"
      }}>
        <div>
          {
            article?.category?.menu?.page_config?.type === 'news' && <Typography.Text style={{marginRight: '1em'}}>
              { article?.date}
            </Typography.Text>
          }
        </div>
        <div style={{
          background: "var(--color-primary)",
          color: "var(--color-white)",
          padding: "0.5em 1em"
        }}>
          { viewUtils.showCategoryName(article?.category, i18n.language, ' / ') }
        </div>
      </div>
      <div className='article-cover-div' style={{marginBottom: '3em'}}>
        <div className='cover-div'>
          <Image
            src={(viewUtils.prettyWithLang(article?.assets_url, i18n.language) || [])[0]}
            fallback={ErrorImage}
            preview={false}
          />
        </div>
      </div>
      <div className='rich-content ql-editor'>
        {parse(viewUtils.prettyWithLang(article?.content, i18n.language, 'content') || '')}
      </div>
    </>
  }

  const RentArticleView = () => {
    return <>
      <Row gutter={[50, 30]}>
        <Col xs={24} lg={14}>
          <Typography.Text style={{
            background: "var(--color-primary)",
            color: "var(--color-white)",
            padding: "0.5em 1em",
          }}>
            { viewUtils.showCategoryName(article?.category, i18n.language, ' / ') }
          </Typography.Text>
          <Typography.Title className='article-title' style={{marginBottom: '2em', marginTop: '0.5em'}}>
            { viewUtils.prettyWithLang(article?.name, i18n.language)}
          </Typography.Title>
          <ConfigProvider theme={{
            components: {
              Carousel: {
                arrowSize: 30,
                arrowOffset: 4,
              },
            },
          }}>
            <Carousel
              className='article-covers'
              style={{width: '100%', marginBottom: '2em'}}
              arrows={true}
              draggable={true}>
              {
                (viewUtils.prettyWithLang(article?.assets_url, i18n.language) || []).map((asset: any, index: number) => (
                  <div key={index} className='article-cover-div'>
                    <div className='cover-div'>
                      <Image
                        src={asset}
                        fallback={ErrorImage}
                        // preview={false}
                      />
                    </div>
                  </div>
                ))
              }
            </Carousel>
          </ConfigProvider>
          <Row gutter={[16, 16]}>
            {
              (viewUtils.prettyWithLang(article?.assets_url, i18n.language) || []).map((asset_url: any, index: number) => (
                <Col span={8} key={index}>
                  <div className='article-cover-div'>
                    <div className='cover-div'>
                      <Image
                        src={asset_url}
                        fallback={ErrorImage}
                      />
                    </div>
                  </div>
                </Col>
              ))
            }
          </Row>
        </Col>
        <Col xs={24} lg={10}>
          <div style={{
            fontSize: '1.3em',
            padding: '1.2em 0.5em',
            borderTop: '1px solid var(--color-border)',
            borderBottom: '1px solid var(--color-border)'
          }}>
            { `${t("article.rental_price")}: ${viewUtils.prettyWithLang(article?.content, i18n.language, 'rent') || ''}`}
          </div>
          <ConfigProvider theme={{
            components: {
              Tabs: {
                horizontalItemPaddingLG: "16px 2em",
              },
            },
          }}>
            <Tabs
              size='large'
              centered={true}
              items={[
                {
                  key: 'characteristic',
                  label: t("article.characteristic"),
                  children: <div className='rich-content ql-editor' style={{ padding: '1.2em 0.5em' }}>
                    {parse(viewUtils.prettyWithLang(article?.content, i18n.language, 'characteristic') || '')}
                  </div>,
                },
                {
                  key: 'accessories',
                  label: t("article.accessories"),
                  children: <div className='rich-content ql-editor' style={{ padding: '1.2em 0.5em' }}>
                    {parse(viewUtils.prettyWithLang(article?.content, i18n.language, 'accessories') || '')}
                  </div>,
                }
              ]}
            />
          </ConfigProvider>
        </Col>
      </Row>

      <div style={{
        fontSize: '1.3em',
        padding: '1.2em 0.5em',
        borderTop: '1px solid var(--color-border)',
        borderBottom: '1px solid var(--color-border)',
        marginTop: '3em',
        textAlign: 'center'
      }}>
        { t("article.specification") }
      </div>
      <div className='rich-content ql-editor' style={{ padding: '3em 0.5em', borderBottom: '1px solid var(--color-border)' }}>
        {parse(viewUtils.prettyWithLang(article?.content, i18n.language, 'specification') || '')}
      </div>
    </>
  }

  if(!article?.id) {return null;}

  return (
    <div className='max-content' style={{ marginTop: '8vh', marginBottom: '10vh' }}>
      {
        article?.category?.menu?.page_config?.type === 'rent' ?
          <RentArticleView /> : <CommonArticleView />
      }
      {
        (articleLinks || []).length > 0 && <>
          <div style={{
            fontSize: '1.5em',
            marginTop: '3em',
            marginBottom: '1em',
            textAlign: 'center'
          }}>
            { t("article.related_equipment") }
          </div>
          <Row gutter={[20, 30]} style={{
            margin: '5em 0',
          }}>
            {
              articleLinks.map((article: any) => (
                <Col
                  xs={12} md={8} lg={6} xl={4}
                  key={article.id}
                  className="article-card"
                  onClick={() => {
                    navigate(`/article/${article.id}`);
                  }}>
                  <div className='article-cover-div' style={{marginBottom: '0.5em'}}>
                    <div className='cover-div'>
                      <Image
                        src={(viewUtils.prettyWithLang(article?.assets_url, i18n.language) || [])[0]}
                        fallback={ErrorImage}
                        preview={false}
                      />
                    </div>
                  </div>
                  <Typography.Text style={{
                    background: "var(--color-primary)",
                    color: "var(--color-white)",
                    padding: "0.2em 1em",
                  }}>
                    {viewUtils.prettyWithLang(article?.category?.name)}
                  </Typography.Text>
                  <div style={{padding: '0.5em 0'}}>
                    <Typography.Paragraph ellipsis={{rows: 2}} style={{margin: '0'}}>
                      { viewUtils.prettyWithLang(article?.name, i18n.language)}
                    </Typography.Paragraph>
                  </div>
                </Col>
              ))
            }
          </Row>
        </>
      }
    </div>
  )
}

export default ArticlePage;